import RejectedQueueContainer from 'containers/Ques/Rejected'
import React from 'react'

const RejectedQueuePage = () => <RejectedQueueContainer />

export default RejectedQueuePage
